/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useNavigate } from "react-router";
import { useAuth } from '@/commons/auth';
import DetailKelas from '../components/DetailKelas'
import getKelasDataDetail from '../services/getKelasDataDetail'
import JadwalTable from "../components/JadwalTable";

import getJadwalKelasList from '../services/getJadwalKelasList'
import DosenTable from "../components/DosenTable";

import getDosenKelasList from '../services/getDosenKelasList'
const DetailKelasPage = props => {
const { kelasId } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	detailKelas: false,
	daftarJadwalKelas: false,
	daftarDosenKelas: false,

	});
	const { setTitle } = useContext(HeaderContext);
	const { id } = useParams();

const [kelasDataDetail, setKelasDataDetail] = useState()
useEffect(() => {
	const fetchData = async () => {
		try {
			setIsLoading(prev => ({...prev, detailKelas: true}))
			const { data: kelasDataDetail } = await getKelasDataDetail({ kelasId:id })
			setKelasDataDetail(kelasDataDetail.data)
		} finally {
			setIsLoading(prev => ({...prev, detailKelas: false}))
		}
	}
	 fetchData()
}, [])
const [jadwalKelasList, setJadwalKelasList] = useState()
	
	
	



	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, daftarJadwalKelas: true}))
				const { data: jadwalKelasList } = await getJadwalKelasList({ kelasId:id })
				setJadwalKelasList(jadwalKelasList.data)
			} finally {
				setIsLoading(prev => ({...prev, daftarJadwalKelas: false}))
			}
		}
		if (checkPermission("ReadJadwalKelas")) { 
			fetchData()
		}
  	}, [])
const [dosenKelasList, setDosenKelasList] = useState()
	
	
	



	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, daftarDosenKelas: true}))
				const { data: dosenKelasList } = await getDosenKelasList({ kelasId:id })
				setDosenKelasList(dosenKelasList.data)
			} finally {
				setIsLoading(prev => ({...prev, daftarDosenKelas: false}))
			}
		}
		if (checkPermission("ReadKelasDosen")) { 
			fetchData()
		}
  	}, [])

	
	useEffect(() => {
		setTitle("Detail Kelas Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kelas
			  	`}>
			  		<Button id="_OaSz8JxAEe-ejYgMQj2CMA" className="p-4 w-full" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			  	
			  <Layouts.ViewContainerButtonLayout>
			  	{checkPermission("SaveJadwalKelas") &&  (
			  	  <Link to={`/kelas/${id}/tambah-jadwal
			  	  `}>
			  	  	<Button id="_Hp4L8CuOEfCz9KF7E6i0TQ" className="p-2 w-full" variant="primary">
			  	  	  Tambah Jadwal
			  	  	</Button>
			  	  </Link>
			  	  
			  	)}
			  	
			  	{checkPermission("CreateKelasDosen") &&  (
			  	  <Link to={`/kelas/${id}/tambah-dosen
			  	  `}>
			  	  	<Button id="_Zm8xsC5QEfCiIOe1nt4Q7w" className="p-2 w-full" variant="primary">
			  	  	  Tambah Dosen
			  	  	</Button>
			  	  </Link>
			  	  
			  	)}
			  	
			
			  </Layouts.ViewContainerButtonLayout>
			</>
		}
	>
<Layouts.DetailContainerLayout
	title={"Detail Kelas"}
	singularName={"Kelas"}
	items={{...kelasDataDetail}}
	isLoading={isLoading.detailKelas}
	isCorrelatedWithAnotherComponent={false}
>
	<DetailKelas {...{ data : { ...kelasDataDetail }}} />
</Layouts.DetailContainerLayout>
{ checkPermission("ReadJadwalKelas") && ( 
<Layouts.ListContainerTableLayout
	title={"Daftar Jadwal Kelas"}
	singularName={"Jadwal"}
	items={[jadwalKelasList]}
	isLoading={isLoading.daftarJadwalKelas}
>
	<JadwalTable
		jadwalKelasList={jadwalKelasList}
		
	/>
</Layouts.ListContainerTableLayout>
)}
{ checkPermission("ReadKelasDosen") && ( 
<Layouts.ListContainerTableLayout
	title={"Daftar Dosen Kelas"}
	singularName={"Dosen"}
	items={[dosenKelasList]}
	isLoading={isLoading.daftarDosenKelas}
>
	<DosenTable
		dosenKelasList={dosenKelasList}
		
	/>
</Layouts.ListContainerTableLayout>
)}

	</Layouts.ViewContainerLayout>
  )
}
export default DetailKelasPage

